import {FC, useEffect, useState} from "react";
import { Image } from "../../../../../../models/Clp";
import { makeStyles } from "@material-ui/core/styles";
import Swal from 'sweetalert2'
import {Button, Typography} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DoneIcon from "@material-ui/icons/Done";
import styled from "styled-components/macro";
import {Grid, Box} from "@mui/material";
import ImageGallery  from "react-image-gallery";

const useStyles = makeStyles({
  needHelp: {
    padding: 0,
    backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
    '-webkit-background-clip': 'text',
    color: 'transparent',
    fontSize: '12px',
    lineHeight: '15px',
    textDecorationLine: 'underline'
  }
})

const Point = styled(DoneIcon)`
  color: #1B2635;
  background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
  border-radius: 50%;
  padding: 4px;
  margin-left: 8px;
  margin-right: 11px;
  height: 20px;
  width: 20px;
`

const DescriptionBlock = styled('div')`
  display: flex;
  flex-direction: row;
  margin: 14px 0;
`

type PropsType = {
  images: any,
  description: string
}
const ChecklistAccordionDetails: FC<PropsType> = ({images, description}) => {
  const { t } = useTranslation()
  const [gallery, setGallery] = useState<{original: string, thumbnail: string, description: string}[]>([])
  const classes = useStyles()

  const openImage = (src: string) => {
    Swal.fire({
      imageUrl: src,
      imageWidth: 1000,
      background: '#233145',
      showConfirmButton: false,
      showCloseButton: true
    })
  }

  useEffect(() => {
    if (images.length > 0) {
      const preparedGallery = images.map((i: any) => ({
        original: i.image,
        thumbnail: i.thumbnails.small,
        description: i.answer ? i.answer.title : ''
      }))
      setGallery(preparedGallery)
    }
  }, [images]);

  return (
    <Box m={2} width={'100%'}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {gallery.length > 0 ? (
            <ImageGallery
              items={gallery}
              showThumbnails={gallery.length > 1}
              showPlayButton={false}
            />
          ) : (
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              height={'100%'}
              style={{background: '#233145'}}
            >
              {t('no_picture')}
            </Box>
          )}
        </Grid>
        <Grid item xs={9}>
          <Box
            display={'flex'}
            style={{background: '#233145'}}
            height={'100%'}
            p={2}
          >
            {description ? <Point/> : null}
            <Box>
              <Typography>{description}</Typography>
              <Button
                  size="small"
                  className={classes.needHelp}
                  component={Link}
                  to="/customer-support"
              >
                {t('CLP_Need_help')}
              </Button>
            </Box>

          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ChecklistAccordionDetails
